<template>
  <div class="animated revealUp">
    <div class="section-title mb-4">{{ $t('view') }} {{ $t('userAuditLog') }}</div>
    <div class="white-wrapper">
      <div class="mt-3 mb-4">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div
            v-if="userLogs && userLogs.length >0 && userLogs[0].username"
            class="col-lg-4 col-xl-3 align-self-center mb-4"
          >{{ $t('name') }} : {{userLogs[0].username}}</div>

          <div
            v-if="userLogs && userLogs.length >0 && userLogs[0].cine_name"
            class="col-lg-4 col-xl-3 align-self-center mb-4"
          >{{ $tc('cinema', 1) }} : {{userLogs[0].cine_name}}</div>

          <div
            class="col-lg-4 col-xl-3 align-self-center mb-4"
          >{{ $t("Date") }} : {{date | dateparse}}</div>
          <div class="d-flex align-items-center">
            <div class="mx-2">
              <b-dropdown name="listview" id="listview" variant="outline-blue">
                <template v-slot:button-content>
                  Viewing&nbsp;
                  <strong>{{selectedvalue}}</strong>
                  &nbsp;Of&nbsp;
                  <strong>{{ rows }}</strong>
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in viewingnumbers"
                  :key="listIndex"
                  @click="onDropDownChangeValue(list.name)"
                  href="#"
                >{{list.name}}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="swc-report fs-12">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th style="width: 15%;">Time</th>
              <th style="width: 15%;">Action</th>
              <th style="width: 70%;">Description</th>
            </tr>
          </thead>
          <tbody v-for="(user, userIndex) in userLogs" :key="userIndex" class="sph-report">
            <tr>
              <td>{{user.created_at | fulldatemonparse}}</td>
              <td>{{user.ual_page_name}}</td>
              <td style="text-align: left;">{{user.ual_action}}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td colspan="3">
                <h3 v-if="userLogs && userLogs.length == 0" class="ml-3">{{ 'No records found' }}</h3>
              </td>
            </tr>
          </tbody>
        </table>
        <b-pagination
          v-if="userLogs && userLogs.length > 0"
          v-model="currentPage"
          :total-rows="rows"
          @change="onChangePagination($event)"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import CinemasService from "@/services/CinemasService";
import UserService from "@/services/UserService";

import MasterService from "@/services/MasterService";
import SetupService from "@/services/SetupService";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";

export default {
  components: { DatePicker, Multiselect },
  data() {
    return {
      userLogs: [],
      requestObject: {
        user_id: null,
        login_time: null,
        logout_time: null
      },
      date: "",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ]
    };
  },
  beforeMount() {
    console.log("this.$route.query :", this.$route.query);

    // let user_Id = this.$route.query.user_id;
    // let login_Time = this.$route.query.login_time;
    // let logout_Time = this.$route.query.logout_time;
    this.date = this.$route.query.date;

    this.requestObject = {
      ...this.requestObject,
      ...this.$route.query
    };
    this.getAuditLogs();
  },
  methods: {
    getAuditLogs: function() {
      console.log("this.requestObject :", this.requestObject);
      let loader = this.$loading.show()
      let payload = {
        ...this.requestObject,
        user_id: this.requestObject.user_id,
        login_time: moment(this.requestObject.login_time).valueOf(),
        logout_time: moment(this.requestObject.logout_time).valueOf(),
        currentPage: this.currentPage,
        perPage: this.perPage
      };
      MasterService.getLogs(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.userLogs = data.Records;
            this.rows = data.totalRows;
            if (this.rows <= this.selectedvalue) {
              this.selectedvalue = this.rows;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError).finally(() => {
          loader.hide()
        })
    },
    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getAuditLogs();
      } else {
        this.currentPage = event;
        this.getAuditLogs();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    }
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/UserAuditLog/viewUserAuditLog.vue